import React from 'react';
import { Routing as NeoRouting } from '@singularsystems/neo-core';
import { Routing } from '@singularsystems/neo-react';
import { AppService, Types } from '../../Services/AppService';
import RegisterView from '../../Views/Registration/RegisterView';
import { investorProfileRoute } from '../../Services/RouteService';
import KYCDDRegisterView from '../../Views/Registration/KYCDDRegisterView';

class RouteView extends Routing.RouteView {

    private investorService = AppService.get(Types.Services.CurrentInvestorService);
    private navigation = AppService.get(Types.Neo.Routing.NavigationHelper);
    private config = AppService.get(Types.Config);

    constructor(props: any) {
        super(props, AppService.get(Types.Services.RouteService).routes);

        this.getForbiddenComponent = (route) => <h2>Forbidden</h2>;
        this.getSigningInComponent = (route) => <div>Signing in...</div>;
    }

    protected getAuthorisedComponent(route: NeoRouting.IRoute, path: string) {

        if (!route.allowAnonymous) {

            const investorData = this.investorService.investorData;
            if (investorData) {
                if (investorData.investor === null) {
                    return <div>Restoring profile...</div>
                }
                if (investorData.mustCompleteRegistration) {
                    if (this.config.enableKYCDDRegistrations && investorData.investor.externalRegistrationStepID !== 0) {
                        setTimeout(() => this.navigation.navigateToView(KYCDDRegisterView), 0);
                        return undefined; // <Redirect to={this.navigation.getPathForView(KYCDDRegisterView)} />
                    } else {
                        setTimeout(() => this.navigation.navigateToView(RegisterView), 0);
                        return undefined; // <Redirect to={this.navigation.getPathForView(RegisterView)} />
                    }
                }
                if (!investorData.readyToInvest && route.path !== investorProfileRoute.path) {
                    setTimeout(() => this.navigation.navigateInternal(investorProfileRoute.path!), 0);
                    return undefined; // <Redirect to={investorProfileRoute.path!} />
                }
            }
        }

        return super.getAuthorisedComponent(route, path);
    }
}

export default RouteView;